<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive">
    </router-view>
  </div>
</template>

<script>

export default {
  name: "App",
};

</script>

<style lang="less">
.theme {
  margin: 0px;
  padding: 0;
  box-sizing: border-box;
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
}
body {
  margin: 0px;
  padding: 0;
  box-sizing: border-box;
}
ul {
  list-style-type: none; /*消除项目符号*/
  margin: 0; /*消除外边距*/
  padding: 0; /*消除内边距*/
}
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
li {
  cursor: pointer;
}
</style>
